import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import './AddFieldButton.css';

const FIELD_TYPES = [
  {
    category: 'Text Entry',
    fields: [
      { type: 2, text: 'Long Text', icon: '/form_icons/2.svg' },
      { type: 17, text: 'Rich Text Editor', icon: '/form_icons/17.svg' },
      { type: 9, text: 'Short Text', icon: '/form_icons/9.svg' },
    ],
  },
  {
    category: 'Selection',
    fields: [
      { type: 5, text: 'Checkbox', icon: '/form_icons/5.svg' },
      { type: 10, text: 'Dropdown', icon: '/form_icons/10.svg' },
      { type: 4, text: 'Radio Button', icon: '/form_icons/4.svg' },
    ],
  },
  {
    category: 'Multi-item',
    fields: [
      { type: 12, text: 'List', icon: '/form_icons/12.svg' },
      { type: 19, text: 'Repeatable Section', icon: '/form_icons/19.svg' },
      { type: 15, text: 'Table', icon: '/form_icons/15.svg' },
    ],
  },
  {
    category: 'Data',
    fields: [
      { type: 7, text: 'Calendar', icon: '/form_icons/7.svg' },
      { type: 13, text: 'E-Signature', icon: '/form_icons/13.svg' },
      { type: 3, text: 'Map', icon: '/form_icons/3.svg' },
      { type: 1, text: 'Number Input', icon: '/form_icons/1.svg' },
      { type: 6, text: 'Upload File', icon: '/form_icons/6.svg' },
      { type: 20, text: 'Image Annotation', icon: '/form_icons/20.svg' },
      { type: 21, text: 'Address', icon: '/form_icons/9.svg' },
    ],
  },
  {
    category: 'Layout & Content',
    fields: [
      { type: 11, text: 'Content Block', icon: '/form_icons/11.svg' },
      { type: 16, text: 'Embed video', icon: '/form_icons/16.svg' },
      { type: 14, text: 'File preview', icon: '/form_icons/14.svg' },
      { type: 8, text: 'Page Break', icon: '/form_icons/8.svg' },
    ],
  },
];

const AddFieldButton = ({ onFieldSelect, position, className = '', isEmptyState = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFieldSelect = fieldType => {
    onFieldSelect(fieldType, position);
    handleClose();
  };

  const containerClass = `add-field-button-container ${className} ${
    isEmptyState ? 'empty-state' : ''
  }`.trim();

  return (
    <div className={containerClass}>
      <Button
        variant="outlined"
        startIcon={<Add />}
        onClick={handleClick}
        className="add-field-button"
        size="small"
      >
        Add Field
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="add-field-menu"
        PaperProps={{
          className: 'add-field-menu-paper',
        }}
      >
        {FIELD_TYPES.map((category, categoryIndex) => (
          <div key={category.category}>
            {categoryIndex > 0 && <Divider />}
            <Typography className="field-category-title" variant="caption">
              {category.category}
            </Typography>
            {category.fields.map(field => (
              <MenuItem
                key={field.type}
                onClick={() => handleFieldSelect(field)}
                className="field-menu-item"
              >
                <ListItemIcon className="field-menu-icon">
                  <img src={field.icon} alt={field.text} />
                </ListItemIcon>
                <ListItemText primary={field.text} />
              </MenuItem>
            ))}
          </div>
        ))}
      </Menu>
    </div>
  );
};

export default AddFieldButton;
